/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamitemidApproveEditor200,
  GetApiV1ExamExamitemidApproveEditor401,
  GetApiV1ExamExamitemidApproveEditor404,
  GetApiV1ExamExamitemidApproveEditor500,
  GetApiV1ExamExamitemidApproveEditorPathParams,
  GetApiV1ExamExamitemidApproveEditorQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidApproveEditor.ts";
import { questionLibraryApproveEditorViewModelSchema } from "../questionLibraryApproveEditorViewModelSchema.ts";

export const getApiV1ExamExamitemidApproveEditorPathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamitemidApproveEditorPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamitemidApproveEditor200Schema = z.lazy(
  () => questionLibraryApproveEditorViewModelSchema,
) as unknown as ToZod<GetApiV1ExamExamitemidApproveEditor200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamitemidApproveEditor401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidApproveEditor401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamExamitemidApproveEditor404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidApproveEditor404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamitemidApproveEditor500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidApproveEditor500>;

export const getApiV1ExamExamitemidApproveEditorQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamitemidApproveEditor200Schema,
) as unknown as ToZod<GetApiV1ExamExamitemidApproveEditorQueryResponse>;
